import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 7a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v2a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3","key":"svg-0"}],["path",{"d":"M3 15a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v2a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3l0 -2","key":"svg-1"}],["path",{"d":"M7 8l0 .01","key":"svg-2"}],["path",{"d":"M7 16l0 .01","key":"svg-3"}]]

const IconServer = createReactComponent('outline', 'server', 'Server', __iconNode);

export default IconServer;